// Typelizer digest 9432efecf2f986a57e937254e8af104f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /admin/productions */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions', {}, options),
    method: 'get',
  }),

  /** POST /admin/productions */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions', {}, options),
    method: 'post',
  }),

  /** GET /admin/productions/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/new', {}, options),
    method: 'get',
  }),

  /** GET /admin/productions/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:id', params, options),
    method: 'get',
  }),
}
